// Copy for the sessions hub (docs/design/social-plan.md, phase 3): the list in Samen, planning a
// session, answering an invite, the flight a session wraps and the news a session sends. One entry
// per locale; every key exists in all seven (nl is the source, the rest are translations).
export const sessionsCopy = {
  nl: {
    "social.notify.sessions": "Herinneringen voor proeverijen",
    "social.notify.sessions.hint":
      "Een uur van tevoren en als de proeverij begint, en als die verplaatst of afgelast wordt.",
    "social.sessions.title": "Proeverijen",
    "social.sessions.samen.hint": "Gepland, live en geweest",
    "social.sessions.new": "Nieuwe proeverij",
    "social.sessions.tab.upcoming": "Gepland",
    "social.sessions.tab.live": "Live",
    "social.sessions.tab.past": "Geweest",
    "social.sessions.empty.upcoming": "Nog niets gepland. Plan een proeverij met je groep.",
    "social.sessions.empty.live": "Er loopt nu geen proeverij.",
    "social.sessions.empty.past": "Nog geen afgeronde proeverijen.",
    "social.sessions.row.noDate": "Nog geen datum",
    "social.sessions.row.host": "door {name}",
    "social.sessions.row.hosting": "Jij organiseert",
    "social.sessions.row.going": "{going} van {total} komen",
    "social.sessions.row.lapsed": "Verlopen",
    "social.session.action.reschedule": "Nieuwe tijd kiezen",
    "social.session.lapsed.body":
      "Deze proeverij is niet gestart en daarom na een dag afgesloten. Kies een nieuwe tijd om hem terug te halen.",
    "social.sessions.row.cancelled": "Afgelast",
    "social.sessions.rsvp.label": "Kom je?",
    "social.sessions.rsvp.yes": "Ik kom",
    "social.sessions.rsvp.maybe": "Misschien",
    "social.sessions.rsvp.no": "Kan niet",
    "social.sessions.rsvp.state.yes": "komt",
    "social.sessions.rsvp.state.maybe": "misschien",
    "social.sessions.rsvp.state.no": "komt niet",
    "social.sessions.more": "Meer laden",
    "social.sessions.create.title": "Nieuwe proeverij",
    "social.sessions.create.name": "Naam",
    "social.sessions.create.when": "Wanneer (optioneel)",
    "social.sessions.create.group": "Voor een groep",
    "social.sessions.create.noGroup": "Geen groep",
    "social.sessions.create.groupHint": "Alle leden van de groep worden uitgenodigd.",
    "social.sessions.create.submit": "Maak proeverij",
    "social.sessions.leave": "Verlaat proeverij",
    "social.sessions.leave.confirm": "Weg uit deze proeverij?",
    "social.sessions.leave.yes": "Ja, verlaat",
    "social.sessions.calendar": "Zet in agenda",
    "social.sessions.flight.title": "Flight",
    "social.sessions.flight.none": "Er is nog geen flight gekoppeld.",
    "social.sessions.flight.start": "Start een flight",
    "social.sessions.flight.join": "Doe mee met de flight",
    "social.sessions.flight.open": "Open de flight",
    "social.sessions.flight.unlinked":
      "Deze flight hangt niet aan de proeverij. Deel de code, dan kan iedereen toch meedoen.",
    "social.sessions.cancel.confirm.title": "Proeverij afgelasten?",
    "social.sessions.cancel.confirm.body":
      "Iedereen die zou komen krijgt bericht dat het niet doorgaat. Dit kan niet ongedaan worden gemaakt.",
    "social.sessions.cancel.confirm.yes": "Ja, afgelasten",
    "social.sessions.end.confirm.title": "Proeverij beëindigen?",
    "social.sessions.end.confirm.body":
      "De ruimte gaat dicht voor iedereen en de flight wordt afgerond. Dit kan niet ongedaan worden gemaakt.",
    "social.sessions.end.confirm.yes": "Ja, beëindigen",
    "social.sessions.when.past": "Die tijd is al voorbij, dus er komen geen herinneringen.",
    "social.sessions.flight.status.lobby": "Wacht op de start",
    "social.sessions.flight.status.active": "Bezig",
    "social.sessions.flight.status.done": "Klaar",
    "social.sessions.wine": "Wijn {n}",
    "social.sessions.wine.progress": "{done} van {total} ingediend",
    "social.sessions.wine.revealed": "Onthuld",
    "social.sessions.announce.submitted": "{name} diende een notitie in voor wijn {n}.",
    "social.sessions.announce.revealed": "Wijn {n} is onthuld.",
    "social.sessions.announce.joined": "{name} is erbij.",
    "social.sessions.announce.left": "{name} is weg.",
    "social.sessions.you": "jij",
    "social.inbox.update.sessionReminder": "{session} begint over een uur",
    "social.inbox.update.sessionStarting": "{session} begint nu",
    "social.inbox.update.sessionMoved": "{session} is verplaatst",
    "social.inbox.update.sessionCancelled": "{session} is afgelast",
  },
  en: {
    "social.notify.sessions": "Tasting reminders",
    "social.notify.sessions.hint":
      "An hour ahead and when a tasting starts, and when one is moved or cancelled.",
    "social.sessions.title": "Tastings",
    "social.sessions.samen.hint": "Planned, live and past",
    "social.sessions.new": "New tasting",
    "social.sessions.tab.upcoming": "Planned",
    "social.sessions.tab.live": "Live",
    "social.sessions.tab.past": "Past",
    "social.sessions.empty.upcoming": "Nothing planned yet. Plan a tasting with your group.",
    "social.sessions.empty.live": "No tasting is on right now.",
    "social.sessions.empty.past": "No finished tastings yet.",
    "social.sessions.row.noDate": "No date yet",
    "social.sessions.row.host": "by {name}",
    "social.sessions.row.hosting": "You are hosting",
    "social.sessions.row.going": "{going} of {total} coming",
    "social.sessions.row.lapsed": "Lapsed",
    "social.session.action.reschedule": "Pick a new time",
    "social.session.lapsed.body":
      "This tasting was not started, so it closed after a day. Pick a new time to bring it back.",
    "social.sessions.row.cancelled": "Cancelled",
    "social.sessions.rsvp.label": "Are you coming?",
    "social.sessions.rsvp.yes": "I'm coming",
    "social.sessions.rsvp.maybe": "Maybe",
    "social.sessions.rsvp.no": "Can't make it",
    "social.sessions.rsvp.state.yes": "coming",
    "social.sessions.rsvp.state.maybe": "maybe",
    "social.sessions.rsvp.state.no": "not coming",
    "social.sessions.more": "Load more",
    "social.sessions.create.title": "New tasting",
    "social.sessions.create.name": "Name",
    "social.sessions.create.when": "When (optional)",
    "social.sessions.create.group": "For a group",
    "social.sessions.create.noGroup": "No group",
    "social.sessions.create.groupHint": "Everyone in the group is invited.",
    "social.sessions.create.submit": "Create tasting",
    "social.sessions.leave": "Leave tasting",
    "social.sessions.leave.confirm": "Leave this tasting?",
    "social.sessions.leave.yes": "Yes, leave",
    "social.sessions.calendar": "Add to calendar",
    "social.sessions.flight.title": "Flight",
    "social.sessions.flight.none": "No flight is attached yet.",
    "social.sessions.flight.start": "Start a flight",
    "social.sessions.flight.join": "Join the flight",
    "social.sessions.flight.open": "Open the flight",
    "social.sessions.flight.unlinked":
      "This flight is not linked to the session. Share the code so everyone can still join.",
    "social.sessions.cancel.confirm.title": "Cancel this tasting?",
    "social.sessions.cancel.confirm.body":
      "Everyone who was coming is told it is off. This cannot be undone.",
    "social.sessions.cancel.confirm.yes": "Yes, cancel it",
    "social.sessions.end.confirm.title": "End this tasting?",
    "social.sessions.end.confirm.body":
      "The room closes for everyone and the flight is wrapped up. This cannot be undone.",
    "social.sessions.end.confirm.yes": "Yes, end it",
    "social.sessions.when.past": "That time has already passed, so no reminders will go out.",
    "social.sessions.flight.status.lobby": "Waiting to start",
    "social.sessions.flight.status.active": "In progress",
    "social.sessions.flight.status.done": "Finished",
    "social.sessions.wine": "Wine {n}",
    "social.sessions.wine.progress": "{done} of {total} submitted",
    "social.sessions.wine.revealed": "Revealed",
    "social.sessions.announce.submitted": "{name} submitted a note for wine {n}.",
    "social.sessions.announce.revealed": "Wine {n} was revealed.",
    "social.sessions.announce.joined": "{name} is here.",
    "social.sessions.announce.left": "{name} left.",
    "social.sessions.you": "you",
    "social.inbox.update.sessionReminder": "{session} starts in an hour",
    "social.inbox.update.sessionStarting": "{session} starts now",
    "social.inbox.update.sessionMoved": "{session} has moved",
    "social.inbox.update.sessionCancelled": "{session} was cancelled",
  },
  de: {
    "social.notify.sessions": "Erinnerungen an Verkostungen",
    "social.notify.sessions.hint":
      "Eine Stunde vorher und zum Beginn, und wenn eine Verkostung verschoben oder abgesagt wird.",
    "social.sessions.title": "Verkostungen",
    "social.sessions.samen.hint": "Geplant, live und vergangen",
    "social.sessions.new": "Neue Verkostung",
    "social.sessions.tab.upcoming": "Geplant",
    "social.sessions.tab.live": "Live",
    "social.sessions.tab.past": "Vergangen",
    "social.sessions.empty.upcoming":
      "Noch nichts geplant. Plane eine Verkostung mit deiner Gruppe.",
    "social.sessions.empty.live": "Gerade läuft keine Verkostung.",
    "social.sessions.empty.past": "Noch keine beendeten Verkostungen.",
    "social.sessions.row.noDate": "Noch kein Datum",
    "social.sessions.row.host": "von {name}",
    "social.sessions.row.hosting": "Du lädst ein",
    "social.sessions.row.going": "{going} von {total} kommen",
    "social.sessions.row.lapsed": "Verfallen",
    "social.session.action.reschedule": "Neue Zeit wählen",
    "social.session.lapsed.body":
      "Diese Verkostung wurde nicht gestartet und nach einem Tag geschlossen. Wähle eine neue Zeit, um sie zurückzuholen.",
    "social.sessions.row.cancelled": "Abgesagt",
    "social.sessions.rsvp.label": "Kommst du?",
    "social.sessions.rsvp.yes": "Ich komme",
    "social.sessions.rsvp.maybe": "Vielleicht",
    "social.sessions.rsvp.no": "Kann nicht",
    "social.sessions.rsvp.state.yes": "kommt",
    "social.sessions.rsvp.state.maybe": "vielleicht",
    "social.sessions.rsvp.state.no": "kommt nicht",
    "social.sessions.more": "Mehr laden",
    "social.sessions.create.title": "Neue Verkostung",
    "social.sessions.create.name": "Name",
    "social.sessions.create.when": "Wann (optional)",
    "social.sessions.create.group": "Für eine Gruppe",
    "social.sessions.create.noGroup": "Keine Gruppe",
    "social.sessions.create.groupHint": "Alle Mitglieder der Gruppe werden eingeladen.",
    "social.sessions.create.submit": "Verkostung anlegen",
    "social.sessions.leave": "Verkostung verlassen",
    "social.sessions.leave.confirm": "Diese Verkostung verlassen?",
    "social.sessions.leave.yes": "Ja, verlassen",
    "social.sessions.calendar": "Zum Kalender hinzufügen",
    "social.sessions.flight.title": "Flight",
    "social.sessions.flight.none": "Noch kein Flight verknüpft.",
    "social.sessions.flight.start": "Flight starten",
    "social.sessions.flight.join": "Beim Flight mitmachen",
    "social.sessions.flight.open": "Flight öffnen",
    "social.sessions.flight.unlinked":
      "Dieser Flight ist nicht mit der Verkostung verknüpft. Teile den Code, dann kann trotzdem jeder mitmachen.",
    "social.sessions.cancel.confirm.title": "Verkostung absagen?",
    "social.sessions.cancel.confirm.body":
      "Alle, die kommen wollten, erfahren, dass sie ausfällt. Das lässt sich nicht rückgängig machen.",
    "social.sessions.cancel.confirm.yes": "Ja, absagen",
    "social.sessions.end.confirm.title": "Verkostung beenden?",
    "social.sessions.end.confirm.body":
      "Der Raum schließt für alle und der Flight wird abgeschlossen. Das lässt sich nicht rückgängig machen.",
    "social.sessions.end.confirm.yes": "Ja, beenden",
    "social.sessions.when.past": "Diese Zeit ist schon vorbei, deshalb gibt es keine Erinnerungen.",
    "social.sessions.flight.status.lobby": "Wartet auf den Start",
    "social.sessions.flight.status.active": "Läuft",
    "social.sessions.flight.status.done": "Beendet",
    "social.sessions.wine": "Wein {n}",
    "social.sessions.wine.progress": "{done} von {total} abgegeben",
    "social.sessions.wine.revealed": "Aufgedeckt",
    "social.sessions.announce.submitted": "{name} hat eine Notiz zu Wein {n} abgegeben.",
    "social.sessions.announce.revealed": "Wein {n} wurde aufgedeckt.",
    "social.sessions.announce.joined": "{name} ist dabei.",
    "social.sessions.announce.left": "{name} ist weg.",
    "social.sessions.you": "du",
    "social.inbox.update.sessionReminder": "{session} beginnt in einer Stunde",
    "social.inbox.update.sessionStarting": "{session} beginnt jetzt",
    "social.inbox.update.sessionMoved": "{session} wurde verschoben",
    "social.inbox.update.sessionCancelled": "{session} wurde abgesagt",
  },
  fr: {
    "social.notify.sessions": "Rappels de dégustations",
    "social.notify.sessions.hint":
      "Une heure avant et au début, et quand une dégustation est déplacée ou annulée.",
    "social.sessions.title": "Dégustations",
    "social.sessions.samen.hint": "Prévues, en direct et passées",
    "social.sessions.new": "Nouvelle dégustation",
    "social.sessions.tab.upcoming": "Prévues",
    "social.sessions.tab.live": "En direct",
    "social.sessions.tab.past": "Passées",
    "social.sessions.empty.upcoming": "Rien de prévu. Organisez une dégustation avec votre groupe.",
    "social.sessions.empty.live": "Aucune dégustation en cours.",
    "social.sessions.empty.past": "Aucune dégustation terminée pour l'instant.",
    "social.sessions.row.noDate": "Pas encore de date",
    "social.sessions.row.host": "par {name}",
    "social.sessions.row.hosting": "Vous organisez",
    "social.sessions.row.going": "{going} sur {total} viennent",
    "social.sessions.row.lapsed": "Expirée",
    "social.session.action.reschedule": "Choisir une nouvelle heure",
    "social.session.lapsed.body":
      "Cette dégustation n'a pas démarré et s'est fermée au bout d'un jour. Choisis une nouvelle heure pour la rouvrir.",
    "social.sessions.row.cancelled": "Annulée",
    "social.sessions.rsvp.label": "Venez-vous ?",
    "social.sessions.rsvp.yes": "Je viens",
    "social.sessions.rsvp.maybe": "Peut-être",
    "social.sessions.rsvp.no": "Je ne peux pas",
    "social.sessions.rsvp.state.yes": "vient",
    "social.sessions.rsvp.state.maybe": "peut-être",
    "social.sessions.rsvp.state.no": "ne vient pas",
    "social.sessions.more": "Charger plus",
    "social.sessions.create.title": "Nouvelle dégustation",
    "social.sessions.create.name": "Nom",
    "social.sessions.create.when": "Quand (facultatif)",
    "social.sessions.create.group": "Pour un groupe",
    "social.sessions.create.noGroup": "Aucun groupe",
    "social.sessions.create.groupHint": "Tous les membres du groupe sont invités.",
    "social.sessions.create.submit": "Créer la dégustation",
    "social.sessions.leave": "Quitter la dégustation",
    "social.sessions.leave.confirm": "Quitter cette dégustation ?",
    "social.sessions.leave.yes": "Oui, quitter",
    "social.sessions.calendar": "Ajouter à l'agenda",
    "social.sessions.flight.title": "Flight",
    "social.sessions.flight.none": "Aucun flight n'est encore associé.",
    "social.sessions.flight.start": "Démarrer un flight",
    "social.sessions.flight.join": "Rejoindre le flight",
    "social.sessions.flight.open": "Ouvrir le flight",
    "social.sessions.flight.unlinked":
      "Ce flight n'est pas lié à la dégustation. Partage le code pour que tout le monde puisse quand même participer.",
    "social.sessions.cancel.confirm.title": "Annuler la dégustation ?",
    "social.sessions.cancel.confirm.body":
      "Tous ceux qui devaient venir sont prévenus qu'elle n'a pas lieu. Cette action est irréversible.",
    "social.sessions.cancel.confirm.yes": "Oui, annuler",
    "social.sessions.end.confirm.title": "Terminer la dégustation ?",
    "social.sessions.end.confirm.body":
      "La salle se ferme pour tout le monde et le flight est clôturé. Cette action est irréversible.",
    "social.sessions.end.confirm.yes": "Oui, terminer",
    "social.sessions.when.past": "Cette heure est déjà passée, aucun rappel ne sera envoyé.",
    "social.sessions.flight.status.lobby": "En attente du départ",
    "social.sessions.flight.status.active": "En cours",
    "social.sessions.flight.status.done": "Terminé",
    "social.sessions.wine": "Vin {n}",
    "social.sessions.wine.progress": "{done} sur {total} envoyées",
    "social.sessions.wine.revealed": "Dévoilé",
    "social.sessions.announce.submitted": "{name} a envoyé une note pour le vin {n}.",
    "social.sessions.announce.revealed": "Le vin {n} a été dévoilé.",
    "social.sessions.announce.joined": "{name} est là.",
    "social.sessions.announce.left": "{name} est parti.",
    "social.sessions.you": "vous",
    "social.inbox.update.sessionReminder": "{session} commence dans une heure",
    "social.inbox.update.sessionStarting": "{session} commence maintenant",
    "social.inbox.update.sessionMoved": "{session} a été déplacée",
    "social.inbox.update.sessionCancelled": "{session} a été annulée",
  },
  es: {
    "social.notify.sessions": "Recordatorios de catas",
    "social.notify.sessions.hint":
      "Una hora antes y al empezar, y cuando una cata se mueve o se cancela.",
    "social.sessions.title": "Catas",
    "social.sessions.samen.hint": "Previstas, en directo y pasadas",
    "social.sessions.new": "Nueva cata",
    "social.sessions.tab.upcoming": "Previstas",
    "social.sessions.tab.live": "En directo",
    "social.sessions.tab.past": "Pasadas",
    "social.sessions.empty.upcoming": "Nada previsto. Organiza una cata con tu grupo.",
    "social.sessions.empty.live": "Ahora no hay ninguna cata en curso.",
    "social.sessions.empty.past": "Todavía no hay catas terminadas.",
    "social.sessions.row.noDate": "Aún sin fecha",
    "social.sessions.row.host": "de {name}",
    "social.sessions.row.hosting": "Tú organizas",
    "social.sessions.row.going": "Vienen {going} de {total}",
    "social.sessions.row.lapsed": "Caducada",
    "social.session.action.reschedule": "Elegir otra hora",
    "social.session.lapsed.body":
      "Esta cata no empezó y se cerró al cabo de un día. Elige otra hora para recuperarla.",
    "social.sessions.row.cancelled": "Cancelada",
    "social.sessions.rsvp.label": "¿Vienes?",
    "social.sessions.rsvp.yes": "Voy",
    "social.sessions.rsvp.maybe": "Quizá",
    "social.sessions.rsvp.no": "No puedo",
    "social.sessions.rsvp.state.yes": "viene",
    "social.sessions.rsvp.state.maybe": "quizá",
    "social.sessions.rsvp.state.no": "no viene",
    "social.sessions.more": "Cargar más",
    "social.sessions.create.title": "Nueva cata",
    "social.sessions.create.name": "Nombre",
    "social.sessions.create.when": "Cuándo (opcional)",
    "social.sessions.create.group": "Para un grupo",
    "social.sessions.create.noGroup": "Sin grupo",
    "social.sessions.create.groupHint": "Se invita a todos los miembros del grupo.",
    "social.sessions.create.submit": "Crear cata",
    "social.sessions.leave": "Salir de la cata",
    "social.sessions.leave.confirm": "¿Salir de esta cata?",
    "social.sessions.leave.yes": "Sí, salir",
    "social.sessions.calendar": "Añadir al calendario",
    "social.sessions.flight.title": "Flight",
    "social.sessions.flight.none": "Aún no hay un flight asociado.",
    "social.sessions.flight.start": "Empezar un flight",
    "social.sessions.flight.join": "Unirse al flight",
    "social.sessions.flight.open": "Abrir el flight",
    "social.sessions.flight.unlinked":
      "Este flight no está vinculado a la cata. Comparte el código para que todos puedan unirse igualmente.",
    "social.sessions.cancel.confirm.title": "¿Cancelar la cata?",
    "social.sessions.cancel.confirm.body":
      "Todos los que iban a venir reciben un aviso de que no se celebra. No se puede deshacer.",
    "social.sessions.cancel.confirm.yes": "Sí, cancelar",
    "social.sessions.end.confirm.title": "¿Terminar la cata?",
    "social.sessions.end.confirm.body":
      "La sala se cierra para todos y el flight se da por concluido. No se puede deshacer.",
    "social.sessions.end.confirm.yes": "Sí, terminar",
    "social.sessions.when.past": "Esa hora ya ha pasado, así que no se enviarán recordatorios.",
    "social.sessions.flight.status.lobby": "Esperando el inicio",
    "social.sessions.flight.status.active": "En curso",
    "social.sessions.flight.status.done": "Terminado",
    "social.sessions.wine": "Vino {n}",
    "social.sessions.wine.progress": "{done} de {total} enviadas",
    "social.sessions.wine.revealed": "Revelado",
    "social.sessions.announce.submitted": "{name} envió una nota del vino {n}.",
    "social.sessions.announce.revealed": "Se reveló el vino {n}.",
    "social.sessions.announce.joined": "{name} está aquí.",
    "social.sessions.announce.left": "{name} se ha ido.",
    "social.sessions.you": "tú",
    "social.inbox.update.sessionReminder": "{session} empieza dentro de una hora",
    "social.inbox.update.sessionStarting": "{session} empieza ahora",
    "social.inbox.update.sessionMoved": "{session} se ha movido",
    "social.inbox.update.sessionCancelled": "{session} se ha cancelado",
  },
  it: {
    "social.notify.sessions": "Promemoria delle degustazioni",
    "social.notify.sessions.hint":
      "Un'ora prima e all'inizio, e quando una degustazione viene spostata o annullata.",
    "social.sessions.title": "Degustazioni",
    "social.sessions.samen.hint": "Previste, in diretta e passate",
    "social.sessions.new": "Nuova degustazione",
    "social.sessions.tab.upcoming": "Previste",
    "social.sessions.tab.live": "In diretta",
    "social.sessions.tab.past": "Passate",
    "social.sessions.empty.upcoming":
      "Niente in programma. Organizza una degustazione con il tuo gruppo.",
    "social.sessions.empty.live": "Nessuna degustazione in corso.",
    "social.sessions.empty.past": "Ancora nessuna degustazione conclusa.",
    "social.sessions.row.noDate": "Ancora senza data",
    "social.sessions.row.host": "di {name}",
    "social.sessions.row.hosting": "Organizzi tu",
    "social.sessions.row.going": "Vengono {going} su {total}",
    "social.sessions.row.lapsed": "Scaduta",
    "social.session.action.reschedule": "Scegli un nuovo orario",
    "social.session.lapsed.body":
      "Questa degustazione non è iniziata e si è chiusa dopo un giorno. Scegli un nuovo orario per riaprirla.",
    "social.sessions.row.cancelled": "Annullata",
    "social.sessions.rsvp.label": "Vieni?",
    "social.sessions.rsvp.yes": "Vengo",
    "social.sessions.rsvp.maybe": "Forse",
    "social.sessions.rsvp.no": "Non posso",
    "social.sessions.rsvp.state.yes": "viene",
    "social.sessions.rsvp.state.maybe": "forse",
    "social.sessions.rsvp.state.no": "non viene",
    "social.sessions.more": "Carica altro",
    "social.sessions.create.title": "Nuova degustazione",
    "social.sessions.create.name": "Nome",
    "social.sessions.create.when": "Quando (facoltativo)",
    "social.sessions.create.group": "Per un gruppo",
    "social.sessions.create.noGroup": "Nessun gruppo",
    "social.sessions.create.groupHint": "Tutti i membri del gruppo sono invitati.",
    "social.sessions.create.submit": "Crea degustazione",
    "social.sessions.leave": "Esci dalla degustazione",
    "social.sessions.leave.confirm": "Uscire da questa degustazione?",
    "social.sessions.leave.yes": "Sì, esci",
    "social.sessions.calendar": "Aggiungi al calendario",
    "social.sessions.flight.title": "Flight",
    "social.sessions.flight.none": "Nessun flight collegato.",
    "social.sessions.flight.start": "Avvia un flight",
    "social.sessions.flight.join": "Unisciti al flight",
    "social.sessions.flight.open": "Apri il flight",
    "social.sessions.flight.unlinked":
      "Questo flight non è collegato alla degustazione. Condividi il codice, così tutti possono partecipare comunque.",
    "social.sessions.cancel.confirm.title": "Annullare la degustazione?",
    "social.sessions.cancel.confirm.body":
      "Chi doveva venire riceve un avviso che non si fa. L'azione non è reversibile.",
    "social.sessions.cancel.confirm.yes": "Sì, annulla",
    "social.sessions.end.confirm.title": "Terminare la degustazione?",
    "social.sessions.end.confirm.body":
      "La sala si chiude per tutti e il flight viene concluso. L'azione non è reversibile.",
    "social.sessions.end.confirm.yes": "Sì, termina",
    "social.sessions.when.past": "Quell'ora è già passata, quindi non partiranno promemoria.",
    "social.sessions.flight.status.lobby": "In attesa dell'inizio",
    "social.sessions.flight.status.active": "In corso",
    "social.sessions.flight.status.done": "Concluso",
    "social.sessions.wine": "Vino {n}",
    "social.sessions.wine.progress": "{done} su {total} inviate",
    "social.sessions.wine.revealed": "Svelato",
    "social.sessions.announce.submitted": "{name} ha inviato una nota per il vino {n}.",
    "social.sessions.announce.revealed": "Il vino {n} è stato svelato.",
    "social.sessions.announce.joined": "{name} è qui.",
    "social.sessions.announce.left": "{name} se n'è andato.",
    "social.sessions.you": "tu",
    "social.inbox.update.sessionReminder": "{session} inizia tra un'ora",
    "social.inbox.update.sessionStarting": "{session} inizia ora",
    "social.inbox.update.sessionMoved": "{session} è stata spostata",
    "social.inbox.update.sessionCancelled": "{session} è stata annullata",
  },
  pt: {
    "social.notify.sessions": "Lembretes de provas",
    "social.notify.sessions.hint":
      "Uma hora antes e no início, e quando uma prova é adiada ou cancelada.",
    "social.sessions.title": "Provas",
    "social.sessions.samen.hint": "Marcadas, ao vivo e passadas",
    "social.sessions.new": "Nova prova",
    "social.sessions.tab.upcoming": "Marcadas",
    "social.sessions.tab.live": "Ao vivo",
    "social.sessions.tab.past": "Passadas",
    "social.sessions.empty.upcoming": "Nada marcado. Organize uma prova com o seu grupo.",
    "social.sessions.empty.live": "Não há nenhuma prova a decorrer.",
    "social.sessions.empty.past": "Ainda não há provas terminadas.",
    "social.sessions.row.noDate": "Ainda sem data",
    "social.sessions.row.host": "de {name}",
    "social.sessions.row.hosting": "Você organiza",
    "social.sessions.row.going": "Vão {going} de {total}",
    "social.sessions.row.lapsed": "Caducada",
    "social.session.action.reschedule": "Escolher nova hora",
    "social.session.lapsed.body":
      "Esta prova não começou e fechou ao fim de um dia. Escolhe uma nova hora para a recuperar.",
    "social.sessions.row.cancelled": "Cancelada",
    "social.sessions.rsvp.label": "Vai?",
    "social.sessions.rsvp.yes": "Eu vou",
    "social.sessions.rsvp.maybe": "Talvez",
    "social.sessions.rsvp.no": "Não posso",
    "social.sessions.rsvp.state.yes": "vai",
    "social.sessions.rsvp.state.maybe": "talvez",
    "social.sessions.rsvp.state.no": "não vai",
    "social.sessions.more": "Carregar mais",
    "social.sessions.create.title": "Nova prova",
    "social.sessions.create.name": "Nome",
    "social.sessions.create.when": "Quando (opcional)",
    "social.sessions.create.group": "Para um grupo",
    "social.sessions.create.noGroup": "Sem grupo",
    "social.sessions.create.groupHint": "Todos os membros do grupo são convidados.",
    "social.sessions.create.submit": "Criar prova",
    "social.sessions.leave": "Sair da prova",
    "social.sessions.leave.confirm": "Sair desta prova?",
    "social.sessions.leave.yes": "Sim, sair",
    "social.sessions.calendar": "Adicionar à agenda",
    "social.sessions.flight.title": "Flight",
    "social.sessions.flight.none": "Ainda não há nenhum flight associado.",
    "social.sessions.flight.start": "Iniciar um flight",
    "social.sessions.flight.join": "Entrar no flight",
    "social.sessions.flight.open": "Abrir o flight",
    "social.sessions.flight.unlinked":
      "Este flight não está ligado à prova. Partilha o código para que todos possam participar na mesma.",
    "social.sessions.cancel.confirm.title": "Cancelar a prova?",
    "social.sessions.cancel.confirm.body":
      "Todos os que iam participar são avisados de que não se realiza. Esta ação não pode ser revertida.",
    "social.sessions.cancel.confirm.yes": "Sim, cancelar",
    "social.sessions.end.confirm.title": "Terminar a prova?",
    "social.sessions.end.confirm.body":
      "A sala fecha para todos e o flight é concluído. Esta ação não pode ser revertida.",
    "social.sessions.end.confirm.yes": "Sim, terminar",
    "social.sessions.when.past": "Essa hora já passou, por isso não serão enviados lembretes.",
    "social.sessions.flight.status.lobby": "À espera do início",
    "social.sessions.flight.status.active": "A decorrer",
    "social.sessions.flight.status.done": "Terminado",
    "social.sessions.wine": "Vinho {n}",
    "social.sessions.wine.progress": "{done} de {total} enviadas",
    "social.sessions.wine.revealed": "Revelado",
    "social.sessions.announce.submitted": "{name} enviou uma nota do vinho {n}.",
    "social.sessions.announce.revealed": "O vinho {n} foi revelado.",
    "social.sessions.announce.joined": "{name} está aqui.",
    "social.sessions.announce.left": "{name} saiu.",
    "social.sessions.you": "você",
    "social.inbox.update.sessionReminder": "{session} começa daqui a uma hora",
    "social.inbox.update.sessionStarting": "{session} começa agora",
    "social.inbox.update.sessionMoved": "{session} foi adiada",
    "social.inbox.update.sessionCancelled": "{session} foi cancelada",
  },
} as const;
